<template>
	<!-- <v-item-group active-class="primary"> -->
	    <v-container fluid>
			<!-- <v-text-field :disabled="!listToComponent.length" class="mt-3" outlined dense hide-details v-model="search" :label="$ml.get('search')" prepend-inner-icon="mdi-magnify" ></v-text-field> -->
	      <v-row dense :justify="renderList.length === 0?'center':'start'" :align="renderList.length === 0?'center':'start'" :style="`overflow-x: hidden; max-height: ${currentHeight-100}px; height: ${currentHeight-100}px;`">
	      	<v-col cols="auto" v-if="renderList.length === 0">
	      		<strong>
	      			{{$ml.get('data_no_found')}}
	      		</strong>
	      	</v-col>
	      	<v-col cols="12">
			    	<div class="video-item">
	            <v-card dark outlined class="fill-height pa-1" width="100%" >
	            	<!-- @click="toggle" -->
	            	<v-row no-gutters>
			        		<template v-for="(itemVideo, idxVideo) in renderList" >
			        			<v-col cols="10"class="body-2 my-2">
			        				<strong class="ml-2">
			        					{{ itemVideo.name || itemVideo.uuid || ""}}
			        				</strong>
			        			</v-col>
								    <v-col cols="2" class="mt-2">								    	
								      <span >
								        {{$ml.get("highest_similarity")}} : 
								        {{( (itemVideo.maxProb || 0)*100).toFixed(2)}} %
								      </span>
								    </v-col>  
			        			<v-col cols="1" >				        				
			        				<div style="height: 100%; text-align: center;">
					        			<img
					        				
								    			:src   = "$Helper.check_img(renderUrlImg(itemVideo.data[0]), $URL)" 
							         		@error = "itemVideo.data[0].urlImg = '/img/no_img_found.png'"
							         		:width  = "120" 
							         		:height = "itemHeight"						         		
							         		class="mt-0 mx-1 d-block mx-auto overlay-image" 
	                				crossorigin=""
	                				:key="'GridTypeLinechartImg'+idxVideo+itemVideo.uuid"

					        			/>
					        			<span> {{ $ml.get('face_selected') }} </span>
				        			</div>	
				        			
						         		<!-- :lazy-src="$logos.mark || ($vuetify.theme.dark ? $logos.login_night : $logos.login)" -->
						         		<!-- :aspect-ratio="16/9" -->
			        			</v-col>
		            		<v-col cols="11">				            					            			
				            	<!-- <ItemGridResultSearch :itemVideo="itemVideo" :infoToFilter="infoToFilter" :idxVideo="idxVideo" ></ItemGridResultSearch> -->
				            	<LineChart :infoData="renderResultData(itemVideo)" :maxProbData="itemVideo.maxProbData" :similarityPercent="itemVideo.maxProb" :openVideo="openVideo" :key="'GridTypeLinechart'+idxVideo+itemVideo.uuid" :videoSrcGrid="infoToFilter.videoUrlPreload" :Threshold="getThreshold()" ></LineChart>
		            		</v-col>
		            		<v-col cols="12">				            					            			
		            			<v-divider></v-divider>
		            		</v-col>
			        		</template>   
	            	</v-row>
            	</v-card>
            </div>
	        </v-col>
	      </v-row>
	      <div class="text-center" v-show="listToComponent.length">
					<v-pagination
				      v-model="page"
				      :length="pageCount"
				      :total-visible="7"
				    ></v-pagination>
				</div>
	    </v-container>
	<!-- </v-item-group> -->
</template>
<style scoped>
.video-container {
	position: relative;
	width: 100%;
	max-width:55vw; /* Ajusta el tamaño máximo si es necesario */
	height: auto;
	aspect-ratio: 16 / 9; /* Mantén el aspecto del video */
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

/*.video-scroller {
	  height: 100vh;
  overflow-y: auto;
}*/
.video-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
}
.overlay-image{
	border: 2px solid #ccc;
  border-radius: 8px;
  top : 0%;

}
</style>
<script type="text/javascript">
	// import {RecycleScroller} from "vue-virtual-scroller"
	// import ItemGridResultSearch from "@/components/face/ItemGridResultSearch.vue"
	import LineChart from "@/components/face/LineChart.vue"
	
	// import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
	export default{
		name : "GridTypeSearchByVideo",
		props : ["listToComponent", "currentHeight", "infoToFilter", "open"],
		components:{  LineChart}, // RecycleScroller, ItemGridResultSearch,
		data : ()=>({
			// itemHeight: 320, // Altura de cada item (video + info)
	  videoProcessor :null,
      scrollerHeight: 600,
      visibleIds: new Set(),
      page: 1,
			itemsPerPage: 6, 
			total : 0,
			search : "",
			itemHeight : 150,

		}),
		mounted(){
			this.renderItemPerPage();
			// console.log(this.infoToFilter.videoUrlPreload)
			//var  itemv = renderList()
			
		},
		watch:{
			currentHeight(val){
				this.renderItemPerPage();
			},
		},

		computed:{
			renderList(){				
				if(this.listToComponent && this.listToComponent.length){
					const tempSimilarity = this.infoToFilter?.similarity ? (this.infoToFilter.similarity/100):0;
					if(this.search){
						const temp = this.listToComponent
							.filter(x=> (x?.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || x.uuid.indexOf(this.search.toLowerCase()) > -1 ) && x.maxProb >= tempSimilarity )
							.sort((a, b) => b.maxProb - a.maxProb); // Ordenar por similitud descendente
						this.total=temp.length;
						return this.renderPaginate(temp);
					}else{
						const temp= this.listToComponent
							.filter(x=> x.maxProb >= tempSimilarity )
							.sort((a, b) => b.maxProb - a.maxProb); // Ordenar por similitud descendente
						this.total=temp.length;
						return this.renderPaginate(temp);
					}
				}
				return [] 
			},
			pageCount(){
				return Math.ceil(this.total/this.itemsPerPage);
			},
		}, // computed
		methods:{
			isInView(id) {
      // Comprobar si el ID está en el conjunto de visibles
     	 return this.visibleIds.has(id);
    	},
			rendercalculateNumberItems(anchoElemento=150, margen = 0) {
				const elemento = document.querySelector('.video-item');
				const anchoTotal = elemento ? elemento.getBoundingClientRect().width : 800;
		  	// console.log(" CHECK ", anchoTotal, anchoElemento)
		  	const espacioPorItem = anchoElemento + margen * 2; // Considera márgenes laterales
		  	return Math.floor(anchoTotal / espacioPorItem) -1;
			},
			renderUrlImg(item){
				if(item){
					// console.log("urlImg ", item)
					item.urlImg=`${item?.path || item?.urlImg}`
					return item.urlImg
				}
			},
			renderUrlVideo(item){
				if(item){
					// console.log("VIDEO ", item)
					return `${this.$URL}${item.infovideo?.url}`
				}
			},
			renderPaginate(items){
				const start = (this.page-1)*this.itemsPerPage
				return items.slice(start, start + this.itemsPerPage); 
			},
			renderItemPerPage(){
				const tempHeight=(this.currentHeight-100)
				this.itemsPerPage=Math.floor((tempHeight<=this.itemHeight?this.itemHeight:tempHeight)/this.itemHeight)
			},
			renderResultData(item){
				if(item){
					return item?.dataFilter && item.dataFilter.length? item.dataFilter : []; // item.data / item.data;//
				}
			},
			getThreshold(){
				return this.infoToFilter?.similarity ? (this.infoToFilter.similarity/100):0;
			},
			openVideo(item, items, video){
				if(item){
					this.infoToFilter.selectedVideoDialog=null;			
					if(this.infoToFilter?.videoUrl != video){						
						if(this.infoToFilter.videoUrl){
							URL.revokeObjectURL(this.infoToFilter.videoUrl)
						}
						this.infoToFilter.videoUrl = video || this.renderUrlVideo(item)//URL.createObjectURL(item.file);					
					}
					
					// Si el item incluye datos del frame capturado, usarlos
					const selectedDialogData = {
						...item, 
						facesSelected : items
					};
					
					// Si hay datos del frame capturado, agregarlos
					if(item.croppedFacePhoto || item.framePhoto || item.originalData) {
						selectedDialogData.croppedFacePhoto = item.croppedFacePhoto;
						selectedDialogData.framePhoto = item.framePhoto;
						selectedDialogData.originalData = item.originalData;
					}
					
					this.infoToFilter.selectedVideoDialog = selectedDialogData;
					this.open.dialogVideo=true;
				}
			},
			// onVideoLoaded(item) {
			// },
			
			
		}, // methods
	}
</script>